import * as React from "react";
const IconPpeSantizerAlt = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      
      fillRule="evenodd"
      d="M14 6a2 2 0 0 0-2 2v7.1A5 5 0 0 0 8 20v17a5 5 0 0 0 5 5h12a5 5 0 0 0 4.584-3h-2.348c-.55.614-1.348 1-2.236 1H13a3 3 0 0 1-3-3v-1h10a1 1 0 1 0 0-2H10v-9h8a1 1 0 1 0 0-2h-8v-3a3 3 0 0 1 3-3h12c.889 0 1.687.386 2.236 1h2.348A5.01 5.01 0 0 0 26 15.1V8a2 2 0 0 0-2-2zm10 2H14v7h10z"
      clipRule="evenodd"
    />
    <path
      
      d="M31 24a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1"
    />
    <path
      
      fillRule="evenodd"
      d="M23.66 33.689A12.12 12.12 0 0 0 30.5 38a12.12 12.12 0 0 0 6.84-4.31A12.35 12.35 0 0 0 40 25.997V22.4c0-.637-.25-1.247-.696-1.697A2.36 2.36 0 0 0 37.627 20H23.374c-.63 0-1.233.253-1.678.703A2.41 2.41 0 0 0 21 22.4v3.598a12.35 12.35 0 0 0 2.66 7.69M38 25.999v.004a10.35 10.35 0 0 1-2.228 6.445 10.13 10.13 0 0 1-5.273 3.492 10.13 10.13 0 0 1-5.271-3.492A10.35 10.35 0 0 1 23 26.002V22.4c0-.113.045-.217.117-.29a.36.36 0 0 1 .257-.11h14.252c.092 0 .185.037.257.11a.41.41 0 0 1 .117.29z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconPpeSantizerAlt;
